// Created this to use new version of Route component compatible
//   with react-router-dom v6.
//
// Using this migration guide:
// https://gist.github.com/mjackson/d54b40a094277b7afdd6b81f51a0393f#get-started-upgrading-today
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Outlet } from 'react-router';
import * as R from 'ramda';

import { retrieveLoggedInUser } from '@atom/actions/userActions';
import { useNavigation } from '@atom/hooks/useNavigation';
import { usePreferences } from '@atom/hooks/usePreferences';
import { useUserProfile } from '@atom/hooks/useUserProfile';
import { Progress } from '@atom/mui';
import { getPortals } from '@atom/utilities/portalUtilities';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

const AuthorizedRouteV6 = () => {
  const [, { params, pathname }] = useNavigation();
  const userProfile = useUserProfile();
  const preferences = usePreferences();

  // If this page navigates via params, use last param as Outlet key
  // - this allows navigation to the same Route element with different params
  // - ex... /budget/:id/:unitId -> /budget/:id/:unitId both render BudgetDetail
  const key = R.isEmpty(params) ? {} : { key: R.last(pathname.split('/')) };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(retrieveLoggedInUser());
  }, []);

  const isLandingPage = pathname === '/';
  const isBudgetingPage = pathname?.includes('/budget');

  const getContent = () => {
    if (
      !userProfile.isVerified &&
      userProfile.userId &&
      !userProfile.isActive
    ) {
      return <Navigate to="/unverified" replace />;
    }

    // Retrieve the current user if they are not currently logged in
    // At this point the user is verified, so if they dont exist they will be created
    if (userProfile.isVerified && !userProfile.userId) {
      dispatch(retrieveLoggedInUser());
    }

    const redirectToLanding = () => {
      const destination =
        getPortals(preferences)[preferences.landingPortal].urlPath;
      return <Navigate to={destination} replace />;
    };

    if (isLandingPage && !isNilOrEmpty(preferences)) {
      return redirectToLanding();
    }

    if (isBudgetingPage && !isNilOrEmpty(preferences)) {
      if (!preferences?.budgeting?.hasBudgeting) {
        return redirectToLanding();
      }
    }

    if (userProfile.isVerified && userProfile.userId) {
      return (
        <div style={{ height: '100%' }}>
          <Outlet {...key} />
        </div>
      );
    }

    return <Progress size={80} thickness={3} style={{ height: '100%' }} />;
  };

  return getContent();
};

export default AuthorizedRouteV6;
